import React from "react"
import deniewImg from "./assets/images/404.gif"
import { Link } from "react-router-dom"
import ConfigUrl from "./config"
import { Card } from "reactstrap"

const PermittedComponent = ({ children, isAccess = false }) => {
  return (
    <>
      {isAccess ? (
        children
      ) : (
        <Card>
          <div className="text-center py-5 bg-white">
            <div>
              <img src={deniewImg} alt="" height={300} />
            </div>
            <h3 className="text-danger fw-bold">Access Denied</h3>
            <h6 className="mb-3">You Don't Have Permission to View This</h6>
            <div>
              <Link
                to={`${ConfigUrl?.appurl}`}
                className="btn px-4 py-2 fs-5 text-white"
                style={{ backgroundColor: "#3d6eb5" }}
              >
                Go to Dashboard
              </Link>
            </div>
          </div>
        </Card>
      )}
    </>
  )
}

export default PermittedComponent
